import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";

import {rpFeatureFlagAiSearchBetaBadge} from "../../app/read_rp_environment_variables";

interface IProps {
    className?: string;
}

export const SemanticSearchBetaBadge = ({className}: IProps) => {
    if (!rpFeatureFlagAiSearchBetaBadge) {
        return null;
    }

    return (
        <Badge as="span" variant="label_bg2" className={cx(betaBadge, className)}>
            BETA
        </Badge>
    );
};

const betaBadge = css({
    "& > span": {
        color: "var(--colors-secondary)",
        fontWeight: 700
    }
});
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";

import {rpFeatureFlagAiSearchBetaBadge} from "../../app/read_rp_environment_variables";

interface IProps {
    className?: string;
}

export const SemanticSearchBetaBadge = ({className}: IProps) => {
    if (!rpFeatureFlagAiSearchBetaBadge) {
        return null;
    }

    return (
        <Badge as="span" variant="label_bg2" className={cx(betaBadge, className)}>
            BETA
        </Badge>
    );
};

const betaBadge = css({
    "& > span": {
        color: "var(--colors-secondary)",
        fontWeight: 700
    }
});
